module.exports = __webpack_public_path__ + "img/rc.0a537a99.png";